var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMachineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3477 1.1C13.3477 1.04477 13.3029 1 13.2477 1H1.44766C1.39243 1 1.34766 1.04477 1.34766 1.1V7.025C1.34766 7.08023 1.39243 7.125 1.44766 7.125H2.96194C3.01717 7.125 3.06194 7.16977 3.06194 7.225V12.319C3.06194 12.3538 3.08003 12.3861 3.10971 12.4043L7.29542 14.968C7.32748 14.9876 7.36783 14.9876 7.39989 14.968L11.5856 12.4043C11.6153 12.3861 11.6334 12.3538 11.6334 12.319V7.225C11.6334 7.16977 11.6781 7.125 11.7334 7.125H13.2477C13.3029 7.125 13.3477 7.08023 13.3477 7.025V1.1Z",
    stroke: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMachineIcon);
export default __webpack_public_path__ + "static/media/machineIcon.a9e06599d0ac6bcee1ecb3f5c6d8a2d7.svg";
export { ForwardRef as ReactComponent };